import type { LucideIcon } from 'lucide-react'
import { ArrowUpRight } from 'lucide-react'
import type * as React from 'react'

import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem
} from '@/components/ui/sidebar'

export function NavSecondary({
  items,
  onItemClick,
  noGroup = false,
  ...props
}: {
  items: {
    title: string
    url: string
    icon: LucideIcon
    external?: boolean
    externalIcon?: LucideIcon
  }[]
  onItemClick?: (url: string) => void
  noGroup?: boolean
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
  const handleClick = (url: string, external: boolean) => {
    if (external) {
      window.open(url, '_blank', 'noopener,noreferrer')
    } else if (onItemClick) {
      onItemClick(url)
    }
  }

  const handleMouseDown = (event: React.MouseEvent, url: string, external: boolean) => {
    // Handle middle click (button 1)
    if (event.button === 1) {
      event.preventDefault()
      if (external) {
        window.open(url, '_blank', 'noopener,noreferrer')
      } else {
        window.open(url, '_blank', 'noopener,noreferrer')
      }
    }
  }

  const menuContent = (
    <SidebarMenu className="gap-0.5">
      {items.map(item => (
        <SidebarMenuItem key={item.title}>
          <SidebarMenuButton 
            onClick={() => handleClick(item.url, !!item.external)}
            onMouseDown={(e) => handleMouseDown(e, item.url, !!item.external)}
            tooltip={item.title}
            size="lg"
            className="!h-10"
          >
            <span className="flex items-center justify-between w-full">
              <span className="text-sm font-medium">{item.title}</span>
              {item.external && (
                <ArrowUpRight className="h-1.5 w-1.5 ml-2 text-muted-foreground" />
              )}
            </span>
          </SidebarMenuButton>
        </SidebarMenuItem>
      ))}
    </SidebarMenu>
  )

  if (noGroup) {
    return menuContent
  }

  return (
    <SidebarGroup {...props}>
      {menuContent}
    </SidebarGroup>
  )
}
